<template>
    <td class="table-persona-invite-cell" :class="className">
        <tippy :content="tooltip">
        <div class="pill">
            <ux-icon :icon="icon" left /> {{text}}
        </div>
    </tippy>
    </td>
</template>
<script>
import TableCellMixin from './TableCellMixin.js';

export default {
    mixins: [TableCellMixin],
    computed: {
        className() {
            if (this.isConnected) {
                return 'connected';
            }

            if (this.isInvited) {
                return 'invited';
            }

            if (this.isManaged) {
                return 'managed';
            }

            return 'empty';
        },
        isConnected() {
            return !!this.row.user;
        },
        isInvited() {
            return !this.isConnected && this.row.collectionEmailAddress;
        },
        isManaged() {
            return !this.isConnected && !this.isInvited;
        },
        email() {
            return this.row.username || this.row.user?.email || this.row.userEmailAddress || this.row.collectionEmailAddress;
        },
        text() {

            const self = this;
            switch (self.className) {
                case 'connected':
                    return 'Qik User'
                    break;
                case 'invited':
                    return 'Invite sent'
                    break;
                case 'managed':
                    return `App user`;
                    break;
                default:
                    return '';
                    break;
            }
        },
        tooltip() {
            const self = this;

            const orgName = self.user?.organisation?.title ? `'${self.user?.organisation?.title}'` : undefined;
            switch (self.className) {
                case 'connected':
                    return `This user can sign in to ${ orgName || 'your organisation'} on the Qik platform.`
                    break;
                case 'invited':
                    return `We've sent an invite to this user to join your organisation on Qik.`
                    break;
                case 'managed':
                    return `This user can only sign in to your applications.`;
                    break;
                default:
                    return '';
                    break;
            }
        },
        icon() {
            switch (this.className) {
                case 'connected':
                    return 'far fa-user'
                    break;
                case 'invited':
                    return 'far fa-envelope'
                    break;
                case 'managed':
                    return 'far fa-user'
                    break;
                default:
                    return
                    break;
            }
        }
    }
}
</script>
<style scoped lang="scss">
td {
    white-space: nowrap;
    text-align: center;

    &.empty * {
        display: none;
    }

    .pill {
        border-radius: 3em;
        padding: 0.3em 0.6em;
        display: inline-block;
        font-size: 0.8em;
        background: #f1f1f1;
        color: #888;
    }

    &.connected {
        .pill {
            background: #e0f3bf;
            color: #299933;
        }
    }

    &.invited {
        .pill {
            background: #fbecbb;
            color: #d17a0e;
        }
    }

    


}
</style>